





















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { TransactionResourceType, TransactionStatus } from '@/modules/transaction/models/transaction-resource.model'
import PanelTransactionSuccess from '@/modules/transaction/components/panel/PanelTransactionSuccess.vue'
import PanelTransactionFailure from '@/modules/transaction/components/panel/PanelTransactionFailure.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import PanelTransactionCard from '@/modules/transaction/components/panel/PanelTransactionCard.vue'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import { PaymentMethods } from '@/modules/transaction/models/payment.model'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'تراکنش',
    page_sub_header: 'مشاهده وضعیت تراکنش'
  },
  metaInfo: {
    title: 'تراکنش'
  },
  components: { PanelTransactionCard, Heading, PanelTransactionFailure, PanelTransactionSuccess }
})
export default class ShowPage extends Vue {
  @Prop() transaction!: TransactionResourceType

  private readonly PaymentMethods = PaymentMethods
  private readonly TransactionStatuses = TransactionStatus
}
